<template>
  <div class="modal fade" id="pcAccessPopupModal" data-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <img
            data-dismiss="modal"
            src="/static/images/icons/close_icon.svg"
            class="close-icon"
            alt="close-icon"
          />
          <div class="card text-center">
            <img
              src="../../../public/static/images/icons/info_icon_active.svg"
              alt="checkbox-icon"
              class="info-logo"
            />
            <div class="card-title">
              <p class="verification-text">
                Your trial subscription has expired
              </p>
            </div>
            <div class="row">
              <div class="col-lg-12 card-text">
                <p class="success-message">
                Please visit our <a href="/layout/market-place">marketplace</a> to purchase a subscription to the Product Classification Tool.
                Please note that the subscription to any other RAMS Premium Services will include complimentary access to the Product Classification Tool.
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 ok-btn">
              <button
                class="btn btn-block emergo-green-button"
                data-dismiss="modal"
              >
                OK
              </button>
            </div>
          </div>
        </div>
        <loader :loadingStatus="loaderStatus"></loader>
      </div>
    </div>
  </div>
</template>
<script>
import Loader from '../UIComponents/Loader.vue';

export default {
  data() {
    return {
      loaderStatus: false,
    };
  },
  components: { Loader },
};
</script>
<style scoped>
.modal .modal-dialog .modal-content {
  border-radius: 10px;
}
.modal .modal-dialog .modal-content .modal-header {
  background: #fff;
  border-radius: 10px;
  padding-top: 45px;
  padding-bottom: 40px;
}
img.info-logo {
  width: 59px;
  height: 59px;
  border-radius: 50%;
  margin-top: 5px;
}
.success-message {
  line-height: 21px;
  font-size: 18px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.7);
  padding: 10px 50px 20px;
}
.ok-btn {
  width: 60%;
  margin: auto;
  float: initial;
}
p.verification-text {
  font-size: 24px;
  padding: 20px 35px 10px;
  color: rgba(0, 0, 0, 0.7);
  font-weight: 500;
  line-height: 28px;
}
.close-icon {
  position: absolute;
  top: 24px;
  right: 20px;
  cursor: pointer;
}
.emergo-green-button,
.emergo-green-button[disabled] {
  color: #ffffff;
}
@media screen and (max-width: 767px) {
  p.verification-text {
    padding: 20px 5px 10px;
  }
  .success-message {
    padding: 10px 25px 20px;
  }
}
</style>
